<template>
  <div class="confirmation-order row">
    <section class="m-section col-xs-12 col-md-6">
      <SfHeading class="sf-heading--left m-base" :title="$t('Shipping details')" :level="3" />
      <div class="m-base">
        <Address :address="shippingAddress.Name ? shippingAddress.Address : shippingAddress" />
      </div>
    </section>
    <section class="m-section col-xs-12 col-md-6">
      <SfHeading class="sf-heading--left m-base" :title="$t('Payment details')" :level="3" />
      <div class="m-base">
        <Address :address="billingAddress" />
        <p v-if="shippingAddress.Name">{{ shippingAddress.Name }}</p>
        <p v-if="shippingAddress.Description">{{ shippingAddress.Description }}</p>
      </div>
    </section>
    <section class="m-section col-xs-12 col-md-6">
      <SfHeading class="sf-heading--left m-base" :title="$t('Shipping Methods')" :level="3" />
      <div class="m-base">
        <p v-if="shippingMethod">{{ shippingMethod }}</p>
        <p v-if="shippingAddress.Name">{{ $t('Pickup point') }}</p>
      </div>
    </section>
    <section class="m-section col-xs-12 col-md-6">
      <SfHeading class="sf-heading--left m-base" :title="$t('Payment Method')" :level="3" />
      <div class="m-base">
        <p>{{ paymentMethod }}</p>
      </div>
    </section>
    <section class="m-section col-xs-12">
      <SfHeading class="sf-heading--left m-base" :title="$t('Products')" :level="3" />
      <div class="m-base">
        <ProductsTable />
      </div>
    </section>
    <section class="m-section col-xs-12">
      <SfHeading class="sf-heading--left m-base" :title="$t('Terms and Notes')" :level="3" />
      <div class="m-base">
        <SfTextarea
          class="textarea"
          :cols="40"
          :rows="10"
          :maxlength="2000"
          :placeholder="$t('Order Note')"
          name="orderNote"
          :value="orderNote"
          v-model="orderNote"
          @input="handleInputChange"
        />
        <SfCheckbox
          :label="$t('I Accept the Terms')"
          name="terms"
          :value="terms"
          v-model="terms"
          @change="handleInputChange"
          :required="true"
          :hintMessage="$t('This field is required')"
          :valid="terms"
          :error-message="$t('This field is required')"
        />
      </div>
    </section>
    <section class="m-section col-xs-12 col-md-6 col-md-offset-6">
      <SfHeading class="sf-heading--left m-base" :title="$t('Totals')" :level="3" />
      <div class="m-base">
        <Totals />
      </div>
    </section>
  </div>
</template>
<script>
import { SfHeading, SfTextarea, SfCheckbox } from '@storefront-ui/vue';
import { Address } from '@/modules/user';
import OrderReview from '../OrderReview.vue';
import ProductsTable from './ProductsTable.vue';
import Totals from '../../Totals.vue';

export default {
  name: 'ReviewOrder',
  mixins: [OrderReview],
  components: {
    SfHeading,
    SfTextarea,
    SfCheckbox,
    Address,
    ProductsTable,
    Totals,
  },
  data() {
    return {
      orderNote: '',
      terms: true,
    };
  },
  props: {
    cart: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({
        orderNote: '',
        terms: true,
      }),
    },
  },
  methods: {
    handleInputChange() {
      this.$emit('input', {
        terms: this.terms,
        orderNote: this.orderNote,
      });
    },
  },
  watch: {
    value: {
      handler() {
        this.orderNote = this.value.orderNote;
        this.terms = this.value.terms;
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/_helpers';
@import 'src/scss/_breakpoint.scss';

.m-base {
  margin-top: var(--spacer-xs);
  margin-bottom: var(--spacer-xs);
}

.m-section {
  margin-bottom: 20px;
}

.textarea {
  --textarea-width: 100%;
}

/deep/ textarea {
  box-sizing: border-box;
}

/deep/ p {
  font: var(
    --link-font,
    var(--link-font-weight, var(--font-normal)) var(--link-font-size, var(--font-sm)) /
      var(--link-font-line-height, 1.4) var(--link-font-family, var(--font-family-secondary))
  );
  margin-bottom: var(--spacer-sm);
  &:last-child {
    margin: 0;
  }
}
</style>
